

























































































































































































































































































































































import Vue from 'vue'
import PrintAction from './components/PrintAction.vue'
import PrintDeployable from './components/PrintDeployable.vue'
import { DamageType } from '@/class'
import { RangeType } from '@/class'

export default Vue.extend({
  name: 'mech-print',
  components: { PrintAction, PrintDeployable },
  props: {
    mech: {
      type: Object,
      required: true,
    },
    damageTypes: {
      type: Array,
      required: true,
      default: Object.values(DamageType),
    },
    rangeTypes: {
      type: Array,
      required: true,
      default: Object.values(RangeType),
    },
  },
  computed: {
    mounts() {
      return this.mech.MechLoadoutController.ActiveLoadout.AllMounts(
        this.mech.Pilot.has('corebonus', 'cb_improved_armament'),
        this.mech.Pilot.has('corebonus', 'cb_integrated_weapon'),
        this.mech.Pilot.has('CoreBonus', 'cb_superheavy_mounting')
      )
    },
  },
  methods: {
    signed(val: number) {
      return val > -1 ? `+${val}` : `${val}`
    },
  },
})
